// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__3DQ1H","tagH1":"Tag_tagH1__38yLN","optional":"Tag_optional__1qdCm","tagInput":"Tag_tagInput__2t3MC","tagView":"Tag_tagView__19G8b","tagSpan":"Tag_tagSpan__rMrrf"};